export const storedDataKeys = [
  "ACTIVE_WILDFIRES_JSON",

  // current property address as string (| - separated street and city parts, or full search address string, if no address returned)
  "ADDRESS_LINE", // property current full street address, where available
  "ADDRESS_LINE_CITY", // second part of full street address
  "ADDRESS_LINE_STREET", // first part of full street address
  "ADDRESS_LEGAL_DESCRIPTION",
  "ADDRESS_LEGAL_LINE", // used in place of ADDRESS_LINE when searching by legal
  "ADDRESS_PID",
  "ADDRESS_REQUESTED", // address object when searching by legal description
  "ADDRESS_DATA", // current property address object from API response

  "AVM_VALUE", // Number
  "AVM_RANGE_HIGH", // Number
  "AVM_RANGE_LOW", // Number
  "AVM_FAILED", // is set to true on proprty valuation errors

  "BRAND",

  "COMPARABLES", // array of transformed comparables (market value or rental)
  "COMPARABLES_HISTORY",
  "COMPARABLES_NUMBER",
  "COMPARABLES_RADIUS",
  "COMPARABLES_OAKS", // comma-separated list as string, if exists

  "CONFIDENCE_RATE",

  "DATA_SCHEMA",

  "EARTHQUAKE_LANDSLIDE", // Earthquake landslide risk, from EarthquakeScore product
  "EARTHQUAKE_LIQUEFACTION", // Earthquake liquefaction risk, from EarthquakeScore product
  "EARTHQUAKE_PGA", // Earthquake Peak Ground Acceleration, from EarthquakeScore product
  "EARTHQUAKE_TSUNAMI", // Earthquake tsunami risk, from EarthquakeScore product
  "EARTHQUAKE_SOIL", // Earthquake soil type, from EarthquakeScore product
  "EARTHQUAKE_RISK", // Earthquake risk, from EarthquakeScore product
  "EARTHQUAKE_SCORE", // Earthquake score, from EarthquakeScore product

  "ENV_REQUESTED", // enviromental products requested

  "AVM_DESCRIPTION", // Explainability HTML fragment

  "FEATURES_CONF", // Object
  "FEATURES_CURRENT", // JSON string or null
  "FEATURES_INITIAL", // JSON string or null
  // original construction features w/o property stats added
  "FEATURES_PREFILL", // JSON string or null
  "FEATURES_MISSING", // missing construction features data keys
  "FEATURES_UPDATED", // JSON string or null, only updated features with their current values

  "FEATURES_SOURCES",

  "FLOOD_SCORE",
  "FLOOD_MAP_CONF_JSON",

  "GEOCODE", // stores {lat, lng} or null

  "HPI_HISTORICAL_JSON", // JSON-serialized HPIHistorical data

  // property images' URLs:
  // must be updated if expired
  "IMAGE_STREET",
  "IMAGE_MAP",

  "MARKET_METRICS_INITIAL", // JSON-serialized Market Metrics initial data
  "MARKET_METRICS_JSON", // JSON-serialized Market Metrics data

  "MUNICIPAL_CODE",
  "NEIGHBOURHOOD_NAME",

  "OAK",

  "PROPERTY_ASSESSMENTS",
  "PROPERTY_LISTINGS", // array
  "PROPERTY_PERMITS_JSON", // array
  "PROPERTY_SALES", // array
  "PROPERTY_RENTALS", // array

  "PROPERTY_TIME", // initial property data load timestamp
  "PROPERTY_TYPE", // residential or condominium

  "RENTAL_RANGE", // if populated, array of 2 numbers
  "RENTAL_TYPE", // rental unit type (use null as initial value)
  "RENTAL_VALUE", // number

  "REPORT_URL", // PDF Report URL
  "REPORT_USE_MS", // use Microservice calls for PDF Report (rather than OSS)

  "REQUESTED_PRODUCTS", // list of previously requested products

  "SEARCH_BY_LEGAL", // boolean, indicating that property search was done by legal entries

  "SHOW_RENTAL", // show items related to Rental Valuation?

  "SNAPSHOT_URL", // Property Snapshot PDF URL (used on Market Metrics page)

  "STATS_INITIAL",
  "STATS_UPDATED", // user-updated property stats
  "STATS_CURRENT", // changed but not saved yet

  "VALUATION_INITIAL", // initial valuation data as JSON
  "VALUATION_SNAPSHOT", // updated valuation data as JSON

  "VALUE_CHANGED", // Market Value was recalculated

  "WILDFIRE_SCORE",
  "WILDFIRE_RISK",
];

//------------------------------------------------------------------------------
// The mapping below isn't imported anywhere yet, but is shown here for reference,
// because these global vars are actually used elsewhere
//------------------------------------------------------------------------------
export const userConfigVars = {
  // global settings for comparables
  COMPARABLES_RADIUS: 0,
  COMPARABLES_HISTORY: 0,
  COMPARABLES_NUMBER: 0,

  FEATURES_CONF: null, // property features' data schema

  OVERLORD: false, // Overlord action is allowed

  //  this indicates that initial property data load has finished, either successfully or not
  PROPERTY_SOURCE: "", // 'net' or 'cache' or nothing

  READONLY_PREFILL: false, // user not allowed to edit features (AVMReadOnlyPrefill attribute is set to true)

  REVEAL_EVR: false, // reveal Estimated Value Range on initial data load
  REVEAL_AVM: false, // reveal Market Value and Confidence on initial data load
  REVIEW_ALLOWED: false, // flag for Submit For Review button

  SIGNING_OUT: false, // login throttling flag
};

// API errors related to products loaded on initial OSS data call,
// but used elsewhere
const productInitErrorKeys = [
  "ASSESSMENTS_ERROR",
  "LISTINGS_ERROR",
  "METRICS_ERROR",
  "HPI_ERROR",
  "RENTAL_VALUE_ERROR", // Error message returned by Rental product call
  "RENTALS_LIST_ERROR",
  "SALES_ERROR",
  "STATS_ERROR",
];

// global vars related to API errors

const apiStatusKeys = [
  "ERROR",
  "MESSAGE",
  "AVM_ERROR",
  "AVM_RANGE_ERROR",
  "CONFIDENCE_ERROR",
  "DATA_ERROR",
  "PREFILL_ERROR",
  "IMAGERY_ERROR",
  "REPORT_ERROR",
  "FLOODSCORE_ERROR",
  "WILDFIRE_ERROR",
  "EARTHQUAKE_ERROR",
  "ACTIVE_WILDFIRES_ERROR",
  "DATA_LOADED", // multi-purpose flag
];

export const getPropertyStateKeys = () => [...storedDataKeys, ...productInitErrorKeys];

export const getApiStatusKeys = () => [...apiStatusKeys];

// Misc constants

export const EN = "en";
export const FR = "fr";

export const RENTAL = "RENTAL";
export const SALES = "SALES";
